export default [
	'Niet ingepland',
	'Gepland',
	'Lopend',
	'Afgerond',
];